export default __webpack_public_path__ + "static/media/arrow-left-calendar.fb7f5c87.svg";